import { FeatureName, useIsFeatureEnabled } from '@gripp/shared-logic';
import { SlideAction, useSlideLayout } from '@gripp/shared-ui';
import { useWorkspaceAsset } from 'libs/shared-logic/src/assets/hooks/useWorkspaceAsset';
import { MediaType } from 'libs/shared-logic/src/graphql/enums';
import { Icon } from 'libs/shared-ui/src/components/crop-circle/icons/Icon';
import { useState } from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { useLocation, useNavigate } from 'react-router';
import { NewIssueModal, NewIssueModalProps } from '../../issues';
import { AddButton } from '../../shared/components/addButton/addButton';
import { isActivityOrEditPage } from '../assetUtils';
import { AssetFiltersOld } from './assetFilters-old';

export const AssetFilters = ({
  assetId
}: {
  assetId: string;
}) => {
  // TODO: Crop Circle Redesign: Remove after feature is fully rolled out
  const isCropCircleEnabled = useIsFeatureEnabled(FeatureName.CropCircleRedesign);
  const { workspaceAsset } = useWorkspaceAsset(assetId);
  const workspaceId = workspaceAsset?.workspace?.id ?? '';

  // TODO: Crop Circle Redesign: Remove after feature is fully rolled out
  if (!isCropCircleEnabled) {
    return <AssetFiltersOld assetId={assetId} workspaceId={workspaceId} />;
  }

  // TODO: Crop Circle Redesign: Remove to AssetFiltersBase after feature is fully rolled out
  return <AssetFiltersBase assetId={assetId} workspaceId={workspaceId} />;
};

export const AssetFiltersBase = ({
  assetId,
  workspaceId,
}: {
  assetId: string;
  workspaceId: string;
}) => {
  const [issueModalVisible, setIssueModalVisible] = useState(false);
  const [newIssueModalProps, setNewIssueModalProps] = useState<
    NewIssueModalProps | undefined
  >(undefined);
  const { onSlideChange } = useSlideLayout();
  const location = useLocation();
  const navigate = useNavigate();

  const onIssueComplete = () => {
    setIssueModalVisible(false);
  };
  
  const onAssetEdit = async () => {
    const editPath = `/assets/${assetId}/edit`;
    
    if (!isActivityOrEditPage(location)) {
      await onSlideChange(SlideAction.NEXT);
    }
    
    navigate(editPath);
  };

  return (
    <View style={styles.filtersContainer}>
      <Pressable onPress={onAssetEdit}>
        <Icon name="Settings" size={24} />
      </Pressable>
      <AddButton
        onPress={() => {
          setNewIssueModalProps({
            assetId: assetId,
            workspaceId: workspaceId,
            isOpened: issueModalVisible,
            modalType: 'modal',
            onComplete: onIssueComplete,
          });
          setIssueModalVisible(true);
        }}
      />
      
      {newIssueModalProps && (
        <NewIssueModal
          {...newIssueModalProps}
          isOpened={issueModalVisible}
          acceptedMediaTypes={[MediaType.Image, MediaType.Document]}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 16,
  },
  modal: {
    alignSelf: 'center',
    backgroundColor: 'white',
    padding: 0,
    margin: 0,
    borderRadius: 10,
    width: 560,
    minHeight: 400,
  },
});
